var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "sticky z-10 top-0 bg-white pb-4 p-1 w-full md:mx-4 md:w-[calc(100%-2rem)] md:bg-[var(--custom-bg)]",
      staticStyle: { "--custom-bg": "#f9f9f9", "overflow-anchor": "none" },
      on: { click: _vm.handleClickOverlay },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "h-12 flex items-center justify-between hidden md:flex md:pt-3",
        },
        [
          _c("img", {
            staticClass: "w-40 h-auto cursor-pointer",
            attrs: { src: _vm.logoSrc, alt: "" },
          }),
          _c(
            "div",
            { staticClass: "flex items-center" },
            _vm._l(_vm.tabbarItems, function (item) {
              return _c(
                "div",
                {
                  key: item.name,
                  staticClass:
                    "h-12 flex items-center justify-center px-4 cursor-pointer hover:bg-gray-100 transition-colors duration-200",
                  on: {
                    click: function ($event) {
                      return _vm.handleTabbarClick(item)
                    },
                  },
                },
                [
                  _c("img", {
                    class: ["w-25 h-auto"],
                    attrs: { src: item.icon },
                  }),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _c("div", { ref: "myElement" }, [
        _c(
          "div",
          {
            staticClass: "flex justify-center md:hidden",
            style: {
              height: _vm.logoContainerHeight + "px",
              transition: "height 0.1s ease-out",
              overflow: "hidden",
            },
          },
          [
            _c("div", { staticClass: "flex items-center" }, [
              _c("img", {
                staticClass: "w-40 h-auto cursor-pointer",
                style: {
                  transform: `scale(${_vm.logoScale})`,
                  opacity: _vm.logoOpacity,
                  transition: "transform 0.1s ease-out, opacity 0.1s ease-out",
                  transformOrigin: "center",
                  willChange: "transform, opacity",
                },
                attrs: { src: _vm.logoSrcMobile, alt: "" },
              }),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "pt-1 md:mt-2 md:w-2/5 w-5/7 mx-auto" },
          [
            _c(
              "van-tabs",
              {
                key: "1",
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.active,
                  callback: function ($$v) {
                    _vm.active = $$v
                  },
                  expression: "active",
                },
              },
              _vm._l(_vm.tabs, function (item, index) {
                return _c("van-tab", { key: item.key }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center mb-2 cursor-pointer hover:bg-gray-200",
                      attrs: { slot: "title" },
                      slot: "title",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "icon-container overflow-hidden flex justify-center items-center",
                          style: {
                            height: _vm.containerHeight + "px",
                            transition:
                              "height 0.1s ease-out, margin-bottom 0.1s ease-out",
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "w-8 h-8 z-999",
                            style: {
                              transform: `scale(${_vm.iconScale})`,
                              opacity: _vm.iconOpacity,
                              transition:
                                "transform 0.1s ease-out, opacity 0.1s ease-out",
                              transformOrigin: "center",
                              willChange: "transform, opacity",
                            },
                            attrs: { src: item.icon, alt: "" },
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          style: {
                            transition: "margin-top 0.1s ease-out",
                          },
                        },
                        [_vm._v(" " + _vm._s(item.title) + " ")]
                      ),
                    ]
                  ),
                ])
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass:
            "h-12 rounded flex items-center justify-center relative overflow-visible",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "md:w-2/5 w-5/7 min-h-12 rounded-full border border-gray-200 flex items-center justify-center pl-3",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleSearch.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                staticClass: "w-4 h-4",
                attrs: { src: _vm.searchSrc, alt: "" },
              }),
              _c("van-search", {
                staticClass: "flex-1 p-0 mr-2 pl-2",
                attrs: {
                  "show-action": "",
                  placeholder:
                    _vm.activeTab === 2
                      ? _vm.$t("query.searchText")
                      : _vm.$t("home.searchText"),
                },
                on: { input: _vm.handleInput, search: _vm.handleInputEnter },
                scopedSlots: _vm._u([
                  {
                    key: "action",
                    fn: function () {
                      return [
                        _vm.active == 2
                          ? _c(
                              "van-button",
                              {
                                staticClass: "w-14",
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  color: "#ff7a00",
                                  round: "",
                                },
                                on: { click: _vm.handleInputEnter },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("query.title")) + " "
                                ),
                              ]
                            )
                          : _c("div"),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.searchText,
                  callback: function ($$v) {
                    _vm.searchText = $$v
                  },
                  expression: "searchText",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "van-popup",
        {
          class: [
            "flex items-start justify-center home-container home-popup",
            _vm.popupClass,
          ],
          style: _vm.popupVars,
          attrs: { position: "top" },
          model: {
            value: _vm.showPlaceList,
            callback: function ($$v) {
              _vm.showPlaceList = $$v
            },
            expression: "showPlaceList",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "md:w-2/5 w-5/7 h-140 bg-white rounded-2xl overflow-y-auto border border-gray-200 p-4",
            },
            [
              _vm.popularDestinations.length && _vm.searchText
                ? _c("div", [
                    _c(
                      "h3",
                      { staticClass: "text-sm font-medium text-gray-600 mb-3" },
                      [_vm._v(_vm._s(_vm.$t("home.popularRecommend")))]
                    ),
                    _c(
                      "div",
                      { staticClass: "space-y-3" },
                      _vm._l(_vm.popularDestinations, function (destination) {
                        return _c(
                          "div",
                          {
                            key: destination.id,
                            staticClass:
                              "flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleDestinationClick(destination)
                              },
                            },
                          },
                          [
                            _vm._l(destination.placeIconList, function (item) {
                              return _c("img", {
                                key: item,
                                staticClass: "w-5 h-4 mr-1",
                                attrs: {
                                  src: _vm.imageBaseUrl + item,
                                  alt: destination.place,
                                },
                              })
                            }),
                            _c("span", { staticClass: "text-sm" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.isZh
                                    ? destination.place
                                    : destination.placeEn
                                )
                              ),
                            ]),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm.recentSearches.length > 0
                ? _c("div", { staticClass: "mb-6" }, [
                    _c(
                      "h3",
                      { staticClass: "text-sm font-medium text-gray-600 mb-3" },
                      [_vm._v(_vm._s(_vm.$t("home.recentSearch")))]
                    ),
                    _c(
                      "div",
                      { staticClass: "space-y-2" },
                      _vm._l(_vm.recentSearches, function (search) {
                        return _c(
                          "div",
                          {
                            key: search.id,
                            staticClass:
                              "flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleRecentSearch(search)
                              },
                            },
                          },
                          [
                            _vm._l(search.placeIconList, function (item) {
                              return _c("img", {
                                key: item,
                                staticClass: "w-5 h-4 mr-2",
                                attrs: {
                                  src: _vm.imageBaseUrl + item,
                                  alt: search.place,
                                },
                              })
                            }),
                            _c("span", { staticClass: "text-sm" }, [
                              _vm._v(
                                _vm._s(_vm.isZh ? search.place : search.placeEn)
                              ),
                            ]),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }